import React from 'react';
import BooleanRadioButtons from '../../components/BooleanRadioButtons';
import Card from '../../components/card';
import { InfoCopy, InfoLink } from '../../components/info-link';
import { BorrowerCard, CoborrowerCard } from '../card-lenses';

const getPossessivePronoun = (id) => (id === 'borrower' ? 'your' : 'their');

const Info = (props) => (
  <InfoLink title='How do you define "job function"?' {...props}>
    <InfoCopy>
      Lenders want to assess the stability of your bonus/commission income. To do so they will
      assess whether your current ‘job function’ is something new for you, or a continuation of your
      past work experience. If they believe it is similar enough, borrowers will typically qualify
      bonus/commission income earned from your previous employer.
    </InfoCopy>
  </InfoLink>
);

const FunctionalArea = ({ model, onChange, id, ...cardProps }) => {
  const onContinuityInRoleChange = onChange.bind(null, 'continuityInRole');
  return (
    <Card
      title={`Is ${getPossessivePronoun(id)} current job function similar to ${getPossessivePronoun(
        id
      )} last job?`}
      info={Info}
      {...cardProps}
    >
      <p>
        If {id === 'borrower' ? 'you' : 'they'} have less than two years of receiving
        bonus/commission income from {getPossessivePronoun(id)} current job function, lenders will
        evaluate {getPossessivePronoun(id)} work history.
      </p>
      <BooleanRadioButtons
        name="continuityInRole"
        value={model.get('continuityInRole')}
        onChange={onContinuityInRoleChange}
      />
    </Card>
  );
};

FunctionalArea.id = 'FunctionalArea';

FunctionalArea.completed = ({ model }) => model.get('continuityInRole') != undefined;

export const PrimaryBorrowerFunctionalArea = BorrowerCard(
  FunctionalArea,
  'PrimaryBorrowerFunctionalArea',
  {
    id: 'borrower'
  }
);

export const CoborrowerFunctionalArea = CoborrowerCard(FunctionalArea, 'CoborrowerFunctionalArea', {
  id: 'coborrower'
});



// WEBPACK FOOTER //
// ./src/cards/bonus-cards/functional-area.js